import { Component, Input, ContentChildren, QueryList, AfterContentInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccordionPanelComponent, AccordionVariant } from './accordion-panel.component';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements AfterContentInit, OnDestroy {
  @Input() allowMultiple: boolean = false;
  @Input() variant: AccordionVariant = 'default';

  @ContentChildren(AccordionPanelComponent) panels: QueryList<AccordionPanelComponent>;

  private panelSubs: Subscription[] = [];
  private changesSub: Subscription;

  ngAfterContentInit(): void {
    this.applyVariant();
    this.subscribeToPanels();

    this.changesSub = this.panels.changes.subscribe(() => {
      this.applyVariant();
      this.subscribeToPanels();
    });
  }

  ngOnDestroy(): void {
    this.panelSubs.forEach(s => s.unsubscribe());
    if (this.changesSub) {
      this.changesSub.unsubscribe();
    }
  }

  private applyVariant(): void {
    this.panels.forEach(panel => {
      panel.variant = this.variant;
    });
  }

  private subscribeToPanels(): void {
    this.panelSubs.forEach(s => s.unsubscribe());
    this.panelSubs = [];

    this.panels.forEach(panel => {
      const sub = panel.panelToggle.subscribe((isOpen: boolean) => {
        if (isOpen && !this.allowMultiple) {
          this.closeOtherPanels(panel);
        }
      });
      this.panelSubs.push(sub);
    });
  }

  private closeOtherPanels(openPanel: AccordionPanelComponent): void {
    this.panels.forEach(panel => {
      if (panel !== openPanel) {
        panel.isOpen = false;
      }
    });
  }
}
